import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { nanoid } from "nanoid/non-secure";
import * as React from "react";
import useDevToolsBase from "./useDevToolsBase";
var FlipperModule;
try {
    FlipperModule = require("react-native-flipper");
} catch (e) {
// Do nothing
}
export default function useFlipper(ref) {
    if (FlipperModule == null) {
        throw new Error("Please install the 'react-native-flipper' package in your project to use Flipper integration for React Navigation.");
    }
    var addPlugin = FlipperModule.addPlugin;
    var connectionRef = React.useRef();
    var resetRoot = useDevToolsBase(ref, function(result1) {
        var connection1 = connectionRef.current;
        if (!connection1) {
            return;
        }
        switch(result1.type){
            case "init":
                connection1.send("init", {
                    id: nanoid(),
                    state: result1.state
                });
                break;
            case "action":
                connection1.send("action", {
                    id: nanoid(),
                    action: result1.action,
                    state: result1.state,
                    stack: result1.stack
                });
                break;
        }
    }).resetRoot;
    React.useEffect(function() {
        addPlugin({
            getId: function getId() {
                return "react-navigation";
            },
            onConnect: function onConnect(connection) {
                return _async_to_generator(function() {
                    var on;
                    return _ts_generator(this, function(_state) {
                        connectionRef.current = connection;
                        on = function(event1, listener1) {
                            connection.receive(event1, function(params1, responder1) {
                                try {
                                    var result1 = listener1(params1);
                                    // Return null instead of undefined, otherwise flipper doesn't respond
                                    responder1.success(result1 !== null && result1 !== void 0 ? result1 : null);
                                } catch (e1) {
                                    responder1.error(e1);
                                }
                            });
                        };
                        on("navigation.invoke", function(param) {
                            var method1 = param.method, _param_args = param.args, args1 = _param_args === void 0 ? [] : _param_args;
                            switch(method1){
                                case "resetRoot":
                                    return resetRoot(args1[0]);
                                default:
                                    var _ref_current;
                                    var _ref_current1;
                                    // @ts-expect-error: we want to call arbitrary methods here
                                    return (_ref_current1 = ref.current) === null || _ref_current1 === void 0 ? void 0 : (_ref_current = _ref_current1)[method1].apply(_ref_current, _to_consumable_array(args1));
                            }
                        });
                        on("linking.invoke", function(param) {
                            var method = param.method, _param_args = param.args, args = _param_args === void 0 ? [] : _param_args;
                            var _global_REACT_NAVIGATION_DEVTOOLS_get, _global_REACT_NAVIGATION_DEVTOOLS;
                            var linking = ref.current ? (_global_REACT_NAVIGATION_DEVTOOLS = global.REACT_NAVIGATION_DEVTOOLS) === null || _global_REACT_NAVIGATION_DEVTOOLS === void 0 ? void 0 : (_global_REACT_NAVIGATION_DEVTOOLS_get = _global_REACT_NAVIGATION_DEVTOOLS.get(ref.current)) === null || _global_REACT_NAVIGATION_DEVTOOLS_get === void 0 ? void 0 : _global_REACT_NAVIGATION_DEVTOOLS_get.linking : null;
                            switch(method){
                                case "getStateFromPath":
                                case "getPathFromState":
                                case "getActionFromState":
                                    var _args_;
                                    return linking === null || linking === void 0 ? void 0 : linking[method](args[0], ((_args_ = args[1]) === null || _args_ === void 0 ? void 0 : _args_.trim()) ? eval("(function() { return ".concat(args[1], "; }())")) : linking.config);
                                default:
                                    var _linking;
                                    return linking === null || linking === void 0 ? void 0 : (_linking = linking)[method].apply(_linking, _to_consumable_array(args));
                            }
                        });
                        return [
                            2
                        ];
                    });
                })();
            },
            onDisconnect: function onDisconnect() {
                connectionRef.current = undefined;
            },
            runInBackground: function runInBackground() {
                return false;
            }
        });
    }, [
        addPlugin,
        ref,
        resetRoot
    ]);
}
